export default "__VITE_ASSET__C87M8iG7__"